'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherArrowRight, FeatherCalendar, FeatherFilter, FeatherLock, FeatherPackage, FeatherUser } from '@subframe/core';
import { useMemo, useState } from 'react';
import { Badge, Select, TextField } from '@/shared/components/ui';
import { chaveDoDiaEmSaoPaulo } from '@/shared/formatters';
import type { TrialAction, TrialHistoryEntry, TrialTenant } from '../types';
import { formatarDataCurta, formatarDataHora } from '../utils/trialDateUtils';
import { trialActionIcon, trialActionLabel, trialActionVariant, trialStatusConfig } from '../utils/trialStatusConfig';
import { TrialStatusBadge } from './TrialStatusBadge';
interface HistoricoTrialTimelineProps {
  trials: TrialTenant[];
}
interface FlatHistoryEntry extends TrialHistoryEntry {
  trialId: string;
  trialIndice: number;
  trialDataInicio: string;
  trialStatus: TrialTenant['status'];
}
const ACTION_FILTER_OPTIONS: {
  value: TrialAction | 'TODAS';
  label: string;
}[] = [{
  value: 'TODAS',
  label: 'Todas as ações'
}, {
  value: 'CRIACAO',
  label: trialActionLabel.CRIACAO
}, {
  value: 'EXTENSAO',
  label: trialActionLabel.EXTENSAO
}, {
  value: 'CONVERSAO',
  label: trialActionLabel.CONVERSAO
}, {
  value: 'ENCERRAMENTO_MANUAL',
  label: trialActionLabel.ENCERRAMENTO_MANUAL
}, {
  value: 'BLOQUEIO_AUTOMATICO',
  label: trialActionLabel.BLOQUEIO_AUTOMATICO
}];
export function HistoricoTrialTimeline(t0) {
  const $ = _c(42);
  const {
    trials
  } = t0;
  const [actionFilter, setActionFilter] = useState("TODAS");
  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");
  let t1;
  if ($[0] !== trials) {
    bb0: {
      if (trials.length === 0) {
        let t2;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = [];
          $[2] = t2;
        } else {
          t2 = $[2];
        }
        t1 = t2;
        break bb0;
      }
      const ativos = trials.filter(_temp);
      if (ativos.length > 0) {
        t1 = [...ativos].sort(_temp2);
        break bb0;
      }
      const recente = [...trials].sort(_temp3)[0];
      let t2;
      if ($[3] !== recente) {
        t2 = recente ? [recente] : [];
        $[3] = recente;
        $[4] = t2;
      } else {
        t2 = $[4];
      }
      t1 = t2;
    }
    $[0] = trials;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const statusCards = t1;
  let t2;
  if ($[5] !== trials) {
    t2 = [...trials].sort(_temp4);
    $[5] = trials;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const ciclosOrdenados = t2;
  let t3;
  if ($[7] !== ciclosOrdenados) {
    const list = [];
    ciclosOrdenados.forEach((trial_0, indexFromNewest) => {
      const indice = ciclosOrdenados.length - indexFromNewest;
      trial_0.historico.forEach(entry => {
        list.push({
          ...entry,
          trialId: trial_0.id,
          trialIndice: indice,
          trialDataInicio: trial_0.dataInicio,
          trialStatus: trial_0.status
        });
      });
    });
    t3 = list.sort(_temp5);
    $[7] = ciclosOrdenados;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const flatEntries = t3;
  let t4;
  if ($[9] !== actionFilter || $[10] !== dataFim || $[11] !== dataInicio || $[12] !== flatEntries) {
    let t5;
    if ($[14] !== actionFilter || $[15] !== dataFim || $[16] !== dataInicio) {
      t5 = entry_0 => {
        if (actionFilter !== "TODAS" && entry_0.acao !== actionFilter) {
          return false;
        }
        const entryDate = chaveDoDiaEmSaoPaulo(entry_0.dataHora) ?? entry_0.dataHora.slice(0, 10);
        if (dataInicio && entryDate < dataInicio) {
          return false;
        }
        if (dataFim && entryDate > dataFim) {
          return false;
        }
        return true;
      };
      $[14] = actionFilter;
      $[15] = dataFim;
      $[16] = dataInicio;
      $[17] = t5;
    } else {
      t5 = $[17];
    }
    t4 = flatEntries.filter(t5);
    $[9] = actionFilter;
    $[10] = dataFim;
    $[11] = dataInicio;
    $[12] = flatEntries;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const filteredEntries = t4;
  const isFiltering = actionFilter !== "TODAS" || dataInicio !== "" || dataFim !== "";
  let map;
  if ($[18] !== filteredEntries) {
    map = new Map();
    filteredEntries.forEach(entry_1 => {
      const arr = map.get(entry_1.trialId) ?? [];
      arr.push(entry_1);
      map.set(entry_1.trialId, arr);
    });
    $[18] = filteredEntries;
    $[19] = map;
  } else {
    map = $[19];
  }
  const entriesByTrial = map;
  let t5;
  if ($[20] !== ciclosOrdenados || $[21] !== entriesByTrial) {
    let t6;
    if ($[23] !== entriesByTrial) {
      t6 = trial_1 => (entriesByTrial.get(trial_1.id) ?? []).length > 0;
      $[23] = entriesByTrial;
      $[24] = t6;
    } else {
      t6 = $[24];
    }
    t5 = ciclosOrdenados.filter(t6);
    $[20] = ciclosOrdenados;
    $[21] = entriesByTrial;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  const ciclosVisiveis = t5;
  let t6;
  if ($[25] !== statusCards) {
    t6 = <div className="flex flex-col gap-3">{statusCards.length === 0 ? <div className="flex flex-col gap-4 rounded-[16px] border border-solid border-neutral-200 bg-white p-5 md:flex-row md:items-center md:justify-between"><div className="flex flex-col gap-2"><span className="text-caption-bold font-caption-bold text-subtext-color tracking-wider uppercase">Status atual</span><Badge variant="neutral">Nenhum trial registrado</Badge></div><div className="flex items-center gap-2 text-xs text-neutral-500"><FeatherLock className="h-3.5 w-3.5" />Histórico imutável — não pode ser editado ou excluído</div></div> : <>{statusCards.map((trial_2, idx) => <div key={trial_2.id} className="flex flex-col gap-4 rounded-[16px] border border-solid border-neutral-200 bg-white p-5 md:flex-row md:items-center md:justify-between"><div className="flex flex-col gap-2"><span className="text-caption-bold font-caption-bold text-subtext-color tracking-wider uppercase">{statusCards.length > 1 ? `Status atual · ${idx + 1}/${statusCards.length}` : "Status atual"}</span><div className="flex flex-col gap-2"><div className="flex items-center gap-3"><TrialStatusBadge status={trial_2.status} /><span className="text-body font-body text-default-font">{trial_2.status === "ATIVO" ? `Trial ativo até ${formatarDataCurta(trial_2.dataExpiracao)}` : trial_2.status === "EXPIRADO" ? `Trial expirou em ${formatarDataCurta(trial_2.dataExpiracao)}` : `Último ${trialStatusConfig[trial_2.status].label.toLowerCase()} em ${formatarDataCurta(trial_2.atualizadoEm)}`}</span></div><div className="text-caption font-caption text-subtext-color flex items-center gap-1.5"><FeatherPackage className="h-3.5 w-3.5" />Produto vinculado:{" "}<span className="text-default-font font-medium">{trial_2.produtoNome}</span></div></div></div>{idx === 0 && <div className="flex items-center gap-2 text-xs text-neutral-500"><FeatherLock className="h-3.5 w-3.5" />Histórico imutável — não pode ser editado ou excluído</div>}</div>)}</>}</div>;
    $[25] = statusCards;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  let t7;
  if ($[27] !== actionFilter || $[28] !== dataFim || $[29] !== dataInicio || $[30] !== flatEntries.length || $[31] !== isFiltering) {
    t7 = flatEntries.length > 0 && <div className="flex flex-col gap-3 rounded-[16px] border border-solid border-neutral-200 bg-white p-5 md:flex-row md:items-end"><div className="w-full md:w-64"><Select label={"Tipo de a\xE7\xE3o"} value={actionFilter} onValueChange={value => setActionFilter(value as TrialAction | 'TODAS')}><Select.Content>{ACTION_FILTER_OPTIONS.map(_temp6)}</Select.Content></Select></div><div className="w-full md:w-44"><TextField label="De"><TextField.Input type="date" value={dataInicio} onChange={event => setDataInicio(event.target.value)} /></TextField></div><div className="w-full md:w-44"><TextField label={"At\xE9"}><TextField.Input type="date" value={dataFim} onChange={event_0 => setDataFim(event_0.target.value)} /></TextField></div>{isFiltering && <button type="button" onClick={() => {
        setActionFilter("TODAS");
        setDataInicio("");
        setDataFim("");
      }} className="text-caption-bold font-caption-bold text-brand-600 hover:text-brand-700 flex items-center gap-1 self-end pb-2"><FeatherFilter className="h-3.5 w-3.5" />Limpar filtros</button>}</div>;
    $[27] = actionFilter;
    $[28] = dataFim;
    $[29] = dataInicio;
    $[30] = flatEntries.length;
    $[31] = isFiltering;
    $[32] = t7;
  } else {
    t7 = $[32];
  }
  let t8;
  if ($[33] !== ciclosVisiveis || $[34] !== entriesByTrial || $[35] !== filteredEntries.length || $[36] !== flatEntries.length) {
    t8 = filteredEntries.length === 0 ? <div className="bg-default-background flex flex-col items-center justify-center gap-3 rounded-[16px] border border-dashed border-neutral-200 px-6 py-12 text-center"><span className="text-body-bold font-body-bold text-default-font">{flatEntries.length === 0 ? "Este cliente nunca teve trial registrado" : "Nenhuma a\xE7\xE3o corresponde aos filtros aplicados"}</span><span className="text-body font-body text-subtext-color">{flatEntries.length === 0 ? "Quando um trial for iniciado para este cliente, todas as a\xE7\xF5es aparecer\xE3o aqui." : "Tente ajustar os filtros ou limpe-os para ver o hist\xF3rico completo."}</span></div> : <div className="flex flex-col gap-6">{ciclosVisiveis.map((trial_3, index) => {
        const entries = entriesByTrial.get(trial_3.id) ?? [];
        const cicloIndice = ciclosVisiveis.length === 1 ? null : ciclosVisiveis.length - index;
        return <section key={trial_3.id} className="flex flex-col gap-3">{ciclosVisiveis.length > 1 && <div className="flex flex-wrap items-center gap-x-3 gap-y-1"><span className="text-caption-bold font-caption-bold text-subtext-color tracking-wider uppercase">Ciclo {cicloIndice} · iniciado em {formatarDataCurta(trial_3.dataInicio)}</span><span className="text-caption font-caption text-subtext-color inline-flex items-center gap-1"><FeatherPackage className="h-3 w-3" /><span className="text-default-font font-medium">{trial_3.produtoNome}</span></span><TrialStatusBadge status={trial_3.status} /></div>}<ol className="border-l-2 border-neutral-200">{entries.map((entry_2, entryIndex) => <TimelineEntry key={entry_2.id} entry={entry_2} isLast={entryIndex === entries.length - 1} />)}</ol></section>;
      })}</div>;
    $[33] = ciclosVisiveis;
    $[34] = entriesByTrial;
    $[35] = filteredEntries.length;
    $[36] = flatEntries.length;
    $[37] = t8;
  } else {
    t8 = $[37];
  }
  let t9;
  if ($[38] !== t6 || $[39] !== t7 || $[40] !== t8) {
    t9 = <div className="flex flex-col gap-6">{t6}{t7}{t8}</div>;
    $[38] = t6;
    $[39] = t7;
    $[40] = t8;
    $[41] = t9;
  } else {
    t9 = $[41];
  }
  return t9;
}
function _temp6(opt) {
  return <Select.Item key={opt.value} value={opt.value}>{opt.label}</Select.Item>;
}
function _temp5(a_2, b_2) {
  return new Date(b_2.dataHora).getTime() - new Date(a_2.dataHora).getTime();
}
function _temp4(a_1, b_1) {
  return new Date(b_1.dataInicio).getTime() - new Date(a_1.dataInicio).getTime();
}
function _temp3(a_0, b_0) {
  return new Date(b_0.atualizadoEm).getTime() - new Date(a_0.atualizadoEm).getTime();
}
function _temp2(a, b) {
  return new Date(b.dataInicio).getTime() - new Date(a.dataInicio).getTime();
}
function _temp(trial) {
  return trial.status === "ATIVO";
}
interface TimelineEntryProps {
  entry: FlatHistoryEntry;
  isLast: boolean;
}
function TimelineEntry(t0) {
  const $ = _c(38);
  const {
    entry,
    isLast
  } = t0;
  const Icon = trialActionIcon[entry.acao];
  const variant = trialActionVariant[entry.acao];
  const label = trialActionLabel[entry.acao];
  const dotClass = variant === "success" ? "bg-success-100 text-success-700" : variant === "warning" ? "bg-warning-100 text-warning-700" : variant === "error" ? "bg-error-100 text-error-700" : variant === "brand" ? "bg-brand-100 text-brand-700" : "bg-neutral-100 text-neutral-700";
  const t1 = `relative ml-[-9px] pl-6 ${isLast ? "" : "pb-6"}`;
  const t2 = `absolute top-0 left-0 flex h-4 w-4 items-center justify-center rounded-full border-2 border-white ${dotClass}`;
  let t3;
  if ($[0] !== Icon) {
    t3 = <Icon className="h-2.5 w-2.5" />;
    $[0] = Icon;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = <span className={t2}>{t3}</span>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== label) {
    t5 = <span className="text-body-bold font-body-bold text-default-font">{label}</span>;
    $[5] = label;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="text-caption font-caption text-subtext-color">·</span>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <FeatherCalendar className="h-3 w-3" />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== entry.dataHora) {
    t8 = formatarDataHora(entry.dataHora);
    $[9] = entry.dataHora;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t8) {
    t9 = <span className="text-caption font-caption text-subtext-color flex items-center gap-1">{t7}{t8}</span>;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t5 || $[14] !== t9) {
    t10 = <div className="flex flex-wrap items-center gap-2">{t5}{t6}{t9}</div>;
    $[13] = t5;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <FeatherUser className="h-3 w-3" />;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const t12 = entry.usuarioNome ?? "Sistema (autom\xE1tico)";
  let t13;
  if ($[17] !== t12) {
    t13 = <div className="text-caption font-caption text-subtext-color flex items-center gap-1.5">{t11}{t12}</div>;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== entry.acao || $[20] !== entry.dataExpiracaoAnterior || $[21] !== entry.dataExpiracaoNova) {
    t14 = entry.acao === "EXTENSAO" && entry.dataExpiracaoAnterior && entry.dataExpiracaoNova && <div className="border-warning-200 bg-warning-50 flex items-center gap-2 self-start rounded-[8px] border px-3 py-2 text-xs"><span className="text-warning-700 font-medium">{formatarDataCurta(entry.dataExpiracaoAnterior)}</span><FeatherArrowRight className="text-warning-700 h-3 w-3" /><span className="text-warning-700 font-semibold">{formatarDataCurta(entry.dataExpiracaoNova)}</span></div>;
    $[19] = entry.acao;
    $[20] = entry.dataExpiracaoAnterior;
    $[21] = entry.dataExpiracaoNova;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== entry.acao || $[24] !== entry.contratosCriadosIds) {
    t15 = entry.acao === "CONVERSAO" && entry.contratosCriadosIds && entry.contratosCriadosIds.length > 0 && <div className="bg-brand-50 self-start rounded-[8px] px-3 py-2 text-xs"><span className="text-brand-700 font-medium">{entry.contratosCriadosIds.length}{" "}{entry.contratosCriadosIds.length === 1 ? "contrato criado" : "contratos criados"}{" "}no Módulo 2</span></div>;
    $[23] = entry.acao;
    $[24] = entry.contratosCriadosIds;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== entry.motivo) {
    t16 = entry.motivo && <div className="rounded-[8px] bg-neutral-50 px-3 py-2 text-sm text-neutral-700"><span className="text-caption-bold font-caption-bold text-subtext-color block">Motivo</span><span className="mt-0.5 block">{entry.motivo}</span></div>;
    $[26] = entry.motivo;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t10 || $[29] !== t13 || $[30] !== t14 || $[31] !== t15 || $[32] !== t16) {
    t17 = <div className="flex flex-col gap-2 pl-2">{t10}{t13}{t14}{t15}{t16}</div>;
    $[28] = t10;
    $[29] = t13;
    $[30] = t14;
    $[31] = t15;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t1 || $[35] !== t17 || $[36] !== t4) {
    t18 = <li className={t1}>{t4}{t17}</li>;
    $[34] = t1;
    $[35] = t17;
    $[36] = t4;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  return t18;
}